import GenericButton from "components/Buttons/GenericButton";
import { Link } from "react-router-dom/cjs/react-router-dom.min";

export default function CancelButton({ fullWidth = false, size }) {
  return (
    <GenericButton
      component={Link}
      to="/admin/rent/list"
      id="back-button"
      color="tertiaryRed"
      fullWidth={fullWidth}
      size={size}
    >
      Cancelar
    </GenericButton>
  );
}
